import React from "react";

const Embed = ({ block, last }) => (
  <section>
    <div className="shell">
      {block.embed ? 
        <div
          className={`clear-both aspect-w-16 aspect-h-9${!last ? " mb-7" : ""}`}
          style={{
            "--tw-aspect-h": block.embed.height,
            "--tw-aspect-w": block.embed.width,
          }}
          dangerouslySetInnerHTML={{ __html: block.embed.code, }}
        />
        :
        <div className="clear-both">Embed not found...</div>  
      }
    </div>  
  </section>
)

export default Embed;